import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons/faShoppingCart";
import { colors, font } from "utils/styles";
import DynamicLink from "@components/Reusables/DynamicLink";
import { CartContext } from "contexts/";

export default function CartIcon() {
	const { localCart, setLocalCart } = useContext(CartContext);

	const [cartCount, setCartCount] = useState(0);
	useEffect(() => {
		const cartItemsCount = Object.values(localCart || {}).reduce((acc, cartItem) => {
			let quantity = cartItem.quantity || 0;
			acc = quantity + acc;
			return acc;
		}, 0); //individual item count

		setCartCount(cartItemsCount);
	}, [localCart]);

	return (
		<span className="cartContainer" title={`${cartCount} items in your cart`}>
			<DynamicLink href="/cart">
				<FontAwesomeIcon className="shoppingCart" icon={faShoppingCart} />
				{cartCount === 0 ? null : <div className={`cartCount absolute`}>{cartCount}</div>}
			</DynamicLink>
			<style jsx>{`
				.cartContainer {
					position: relative;
					display: inline-block;
				}
				.cartCount {
					color: ${colors.dark};
					font-size: 12px;
					font-weight: 700;
					left: 60%;
					top: -10px;
					background: ${colors.yellow};
					border-radius: 50%;
					width: 1.5em;
					height: 1.5em;
					line-height: 1.5em;
					text-align: center;
				}
			`}</style>
		</span>
	);
}
